export default __webpack_public_path__ + "static/media/team22.9442adcb.JPG";